module.exports = __webpack_public_path__ + "fonts/notosans-bold-web.f8e28e8.woff2";